import styled from 'styled-components';

export const Text = styled.p`
  font-size: ${props => props.theme.fonts.baseSize};

  span {
    color: ${props => props.theme.colors.yellow};
  }
`;

const StarsCollectedStyled = styled.section`
  bottom: 14%;
  left: 50%;
  position: fixed;
  transform: translate(-50%, 20px);
`;

export default StarsCollectedStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/StarsCollected/StarsCollected.styled.js